module.exports = __webpack_public_path__ + "img/com_txt.e3663a87.png";